module.exports = __webpack_public_path__ + "static/knight_of_the_order-15b4cee31f3ea29d8968ff084b8a43e6.png";